import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { SpecraBadge, SpecraLink, SpecraText } from '@mono/ui-components/ensigns';
import { SpecraKeyValueRow, SpecraSectionHeader } from '@mono/ui-components/lieutenants';
import { renderRouterLink } from '../../../../lib/renderRouterLink';
import { BURDEN_LABELS, RATE_TYPE_LABELS } from '../../../Delivery/Registries/hooks';
import { mappingVariant } from '../../badgeVariants';
import { registryHref } from '../../registryHref';
import { NOT_STATED, usd } from './model';
const field = (label, value)=>/*#__PURE__*/ _jsx(SpecraKeyValueRow, {
        label: label,
        value: value ? /*#__PURE__*/ _jsx("span", {
            children: value
        }) : /*#__PURE__*/ _jsx(SpecraText, {
            tone: "muted",
            children: NOT_STATED
        })
    }, label);
/** Read-only entry detail for the page: as written, mappings, rates, versions. */ export function LaborCategoryEntryDetail({ entry, versions, mappings, rates }) {
    return /*#__PURE__*/ _jsxs("div", {
        className: "space-y-8",
        children: [
            /*#__PURE__*/ _jsxs("section", {
                className: "space-y-3",
                children: [
                    /*#__PURE__*/ _jsx(SpecraSectionHeader, {
                        variant: "group",
                        title: "As written"
                    }),
                    /*#__PURE__*/ _jsxs("div", {
                        className: "space-y-1",
                        children: [
                            /*#__PURE__*/ _jsx(SpecraText, {
                                as: "p",
                                size: "meta",
                                tone: "muted",
                                children: "Description"
                            }),
                            entry.description ? /*#__PURE__*/ _jsx(SpecraText, {
                                as: "p",
                                size: "body-ui",
                                children: entry.description
                            }) : /*#__PURE__*/ _jsx(SpecraText, {
                                as: "p",
                                size: "body-ui",
                                tone: "muted",
                                children: NOT_STATED
                            })
                        ]
                    }),
                    field('Qualifications', entry.qualifications),
                    field('Clearance', entry.clearance),
                    field('Certifications', entry.certifications)
                ]
            }),
            /*#__PURE__*/ _jsxs("section", {
                className: "space-y-3",
                children: [
                    /*#__PURE__*/ _jsx(SpecraSectionHeader, {
                        variant: "group",
                        title: "Mappings"
                    }),
                    mappings.length === 0 && /*#__PURE__*/ _jsx(SpecraText, {
                        as: "p",
                        size: "body-ui",
                        tone: "muted",
                        children: "Not mapped yet. That's fine for a specialized role."
                    }),
                    mappings.map((m)=>/*#__PURE__*/ _jsx(SpecraKeyValueRow, {
                            label: m.toAnchorId ? /*#__PURE__*/ _jsx(SpecraLink, {
                                href: registryHref({
                                    kind: 'LCAT_ANCHOR',
                                    id: m.toAnchorId
                                }) ?? undefined,
                                renderLink: renderRouterLink,
                                children: m.toAnchorTitle
                            }) : m.toEntryTitle || m.fromEntryTitle,
                            value: /*#__PURE__*/ _jsx(SpecraBadge, {
                                variant: mappingVariant(m.status, m.mappingType),
                                children: m.status === 'APPROVED' ? m.mappingType.toLowerCase() : 'needs review'
                            })
                        }, m.id))
                ]
            }),
            /*#__PURE__*/ _jsxs("section", {
                className: "space-y-3",
                children: [
                    /*#__PURE__*/ _jsx(SpecraSectionHeader, {
                        variant: "group",
                        title: "Rates"
                    }),
                    rates.length === 0 && /*#__PURE__*/ _jsx(SpecraText, {
                        as: "p",
                        size: "body-ui",
                        tone: "muted",
                        children: "No rates recorded for this category yet."
                    }),
                    rates.map((r)=>/*#__PURE__*/ _jsx(SpecraKeyValueRow, {
                            label: `${RATE_TYPE_LABELS[r.observationType] ?? r.observationType} · ${r.periodLabel || 'period not stated'}`,
                            value: /*#__PURE__*/ _jsxs("span", {
                                children: [
                                    usd(r.amount),
                                    "/",
                                    r.rateUnit.toLowerCase().replace('hourly', 'hr'),
                                    " ·",
                                    ' ',
                                    BURDEN_LABELS[r.burdenBasis] ?? r.burdenBasis,
                                    " ·",
                                    ' ',
                                    r.source || 'source not recorded'
                                ]
                            })
                        }, r.id))
                ]
            }),
            /*#__PURE__*/ _jsxs("section", {
                className: "space-y-3",
                children: [
                    /*#__PURE__*/ _jsx(SpecraSectionHeader, {
                        variant: "group",
                        title: "History"
                    }),
                    versions.map((v)=>/*#__PURE__*/ _jsx(SpecraKeyValueRow, {
                            label: v.id === entry.id ? `v${v.version} (this version)` : /*#__PURE__*/ _jsxs(SpecraLink, {
                                href: registryHref({
                                    kind: 'LCAT_ENTRY',
                                    id: v.id
                                }) ?? undefined,
                                renderLink: renderRouterLink,
                                children: [
                                    "v",
                                    v.version
                                ]
                            }),
                            value: v.updatedAt ? v.updatedAt.toDate().toLocaleDateString() : ''
                        }, v.id))
                ]
            })
        ]
    });
}
